import React, { useEffect, useState } from 'react'
import {
  Card,
  Form,
  Button,
  Typography,
  Table,
  Radio,
  Row,
  Col,
  Tooltip,
  Tag,
} from 'antd'
import { AvailableSlots } from "../API's/UserApi"
import axiosInstance from '../Utils/axiosInstance'
import { useNavigate } from 'react-router-dom'

const { Title } = Typography

const BookSlot = () => {
  const authUser = JSON.parse(sessionStorage.getItem('userData'))
  const isUserType2 = authUser?.userType == 2

  const [slotData, setSlotData] = useState([])
  const [selectedSlot, setSelectedSlot] = useState(null)

  const navigate = useNavigate()

  useEffect(() => {
    window.history.pushState(null, null, window.location.href)

    const handleBackButton = () => {
      window.history.pushState(null, null, window.location.href)
    }

    window.addEventListener('popstate', handleBackButton)

    return () => {
      window.removeEventListener('popstate', handleBackButton)
    }
  }, [])

  useEffect(() => {
    const mobileNo = sessionStorage.getItem('mobileNo')
    if (mobileNo) {
      getSlotList(mobileNo)
    }
  }, [])

  const getSlotList = async (mobileNo) => {
    try {
      const res = await axiosInstance.get(
        `${AvailableSlots}?mobileNo=${mobileNo}`,
      )
      setSlotData(res.data)
    } catch (error) {
      console.error('Slot API Error', error)
    }
  }

  // Check if any slot already booked (only matters for userType 2)
  const isAlreadyBooked =
    isUserType2 && slotData.some((slot) => slot.isBooked == 1)

  const columns = [
    {
      title: 'Select',
      align: 'center',
      render: (_, record, index) => {
        const disabled =
          record.isActive == 0 ||
          Number(record.intakeAvailable) == 0 ||
          (isUserType2 && (isAlreadyBooked || record.isBooked == 1))

        const tooltipMsg =
          isUserType2 && isAlreadyBooked
            ? 'You have already booked a slot'
            : record.isBooked == 1
            ? 'This slot is already booked'
            : record.isActive == 0 || Number(record.intakeAvailable) == 0
            ? 'Slot not available'
            : ''

        return (
          <Tooltip color="orange" title={tooltipMsg}>
            <Radio
              checked={selectedSlot === index}
              disabled={disabled}
              onChange={() => setSelectedSlot(index)}
            />
          </Tooltip>
        )
      },
    },
    {
      title: 'Time From',
      dataIndex: 'timeFrom',
      align: 'center',
      render: (text, record) => {
        const tooltipMsg =
          record.isBooked == 1
            ? 'This slot is already booked'
            : record.isActive == 0 || Number(record.intakeAvailable) == 0
            ? 'Slot not available'
            : ''

        return (
          <Tooltip color="orange" title={tooltipMsg}>
            <span>
              {text}

              {record.isBooked == 1 ? (
                <Tag color="orange" style={{ marginLeft: 8 }}>
                  Booked
                </Tag>
              ) : record.isActive == 0 ? (
                <Tag color="red" style={{ marginLeft: 8 }}>
                  Inactive
                </Tag>
              ) : null}
            </span>
          </Tooltip>
        )
      },
    },
    {
      title: 'Time To',
      dataIndex: 'timeTo',
      align: 'center',
      render: (text, record) => {
        const tooltipMsg =
          record.isBooked == 1
            ? 'This slot is already booked'
            : record.isActive == 0 || Number(record.intakeAvailable) == 0
            ? 'Slot not available'
            : ''

        return (
          <Tooltip color="orange" title={tooltipMsg}>
            <span>{text}</span>
          </Tooltip>
        )
      },
    },
    {
      title: 'Available Intake',
      dataIndex: 'intakeAvailable',
      align: 'center',
      render: (text, record) => {
        const tooltipMsg =
          record.isBooked == 1
            ? 'This slot is already booked'
            : record.isActive == 0 || Number(record.intakeAvailable) == 0
            ? 'Slot not available'
            : ''

        return (
          <Tooltip color="orange" title={tooltipMsg}>
            <span>{text}</span>
          </Tooltip>
        )
      },
    },
  ]

  const handlePayment = () => {
    if (selectedSlot === null) {
      alert('Please select slot')
      return
    }

    const slot = slotData[selectedSlot]

    navigate('/user/user-payment', { state: { slot } })
  }

  return (
    <div className="payment-container">
      <Card className="payment-card">
        <Row
          align="middle"
          justify="space-between"
          style={{ marginBottom: 10 }}
        >
          <Col xs={24} md={12}>
            <Title level={3} style={{ margin: 0 }}>
              Book Swimming Slot
            </Title>
          </Col>

          <Col xs={24} md={12} style={{ textAlign: 'right' }}>
            <Title level={5} style={{ margin: 0 }}>
              Date - {new Date().toLocaleDateString('en-GB')}
            </Title>

            <div className="slot-legend" style={{ marginTop: 5 }}>
              <span className="legend-box available"></span>
              <span className="legend-text">Available</span>

              <span className="legend-box full"></span>
              <span className="legend-text">Full / Not Available</span>
            </div>
          </Col>
        </Row>

        {isUserType2 && isAlreadyBooked && (
          <div style={{ color: 'red', marginBottom: 10, fontWeight: 600 }}>
            You have already booked a slot.
          </div>
        )}

        <Table
          columns={columns}
          dataSource={slotData}
          pagination={false}
          rowKey={(record, index) => index}
          onRow={(record, index) => {
            const disabled =
              record.isActive == 0 ||
              Number(record.intakeAvailable) == 0 ||
              (isUserType2 && (isAlreadyBooked || record.isBooked == 1))

            return {
              onClick: () => {
                if (disabled) return
                setSelectedSlot(index)
              },
            }
          }}
          rowClassName={(record) => {
            if (record.isActive == 0) {
              return 'slot-disabled'
            }

            if (record.isActive == 1 && record.isBooked == 0) {
              return 'slot-active'
            }

            if (record.isActive == 1 && record.isBooked == 1) {
              return 'slot-booked'
            }

            return ''
          }}
        />

        <Form>
          <Row justify="center" style={{ marginTop: 25 }}>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Button
                type="primary"
                block
                size="large"
                disabled={
                  selectedSlot === null || (isUserType2 && isAlreadyBooked)
                }
                onClick={handlePayment}
              >
                Book Slot
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  )
}

export default BookSlot
